window.addEventListener('DOMContentLoaded', () => {
    const blogFilterPills = document.querySelectorAll('.blog-filter-pill');
    const activeClass = 'active';
   
    blogFilterPills.forEach((pill) => {
       
        pill.addEventListener('click', function (e) {
            e.preventDefault();
            
            let pillIsActive = pill.classList.contains(activeClass);
            blogFilterPills.forEach((p) => p.classList.remove(activeClass));
            if (!pillIsActive) {
                pill.classList.add(activeClass);
            }

            // Re-render the articles section with the new filter or restore to initial state
            fetch(pillIsActive ? this.dataset.restorePath : this.dataset.path)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const targetElement = document.querySelector(".collection");
                    const sourceElement = html.querySelector(".collection");
                    if (targetElement && sourceElement) {
                        targetElement.replaceWith(sourceElement);
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        });
    });
});